/* ===========================================================
   EVM · Editorial
   Revela la sección cuando entra en pantalla: zoom lento de
   salida en la foto y texto escalonado.
   =========================================================== */

/* Con dos instancias de la sección en la misma página, el navegador
   ejecuta este archivo dos veces: si ya está definido, no se repite
   nada (ni la clase ni los listeners de documento). */
if (!customElements.get('evm-editorial')) {

class EvmEditorial extends HTMLElement {
  connectedCallback() {
    // Sin IntersectionObserver, se muestra sin animación
    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-revealed');
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.classList.add('is-revealed');
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.classList.add('is-revealed');
          this.observer.disconnect();
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

if (!customElements.get('evm-editorial')) {
  customElements.define('evm-editorial', EvmEditorial);
}

/* En el editor de temas la sección se recarga: hay que revelarla
   otra vez o se quedaría invisible. */
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('evm-editorial').forEach((el) => {
    el.classList.add('is-revealed');
  });
});

}
